import OrderForm from './root.vue'
import MainNav from './main_nav.vue'
import orderFormList from './order_form_list/router'

const route = {
    path: 'orderForm',
    component: OrderForm,
    children: [{
        path: '',
        redirect: 'nav'
    }, {
        path: 'nav',
        component: MainNav,
        children: [{
            path: '',
            redirect: orderFormList.path
        },
            orderFormList
        ]
    }]
}

export default route
